import { el, onTap } from './dom.ts';
import { navigate } from '../router.ts';
import { t, type MessageKey } from '../i18n/index.ts';

/** Metindeki `{contact}` yer tutucusunu İletişim sayfasına giden bağlantıyla
 *  doldurur. Çevrim içi ödeme yokken paket geçişinin tek yolu o adres; düz
 *  metin olarak kalınca kullanıcı sayfayı alt bilgide arıyordu. */
export function withContactLink(key: MessageKey): Array<Node | string> {
  const [before, after = ''] = t(key).split('{contact}');
  const link = el('button', { class: 'link-inline', type: 'button' }, t('legal.contact'));
  onTap(link, () => navigate('/legal?section=contact'));
  return [before, link, after];
}
